import cx from 'classnames';
import React from 'react';

interface Props {
    children: React.ReactNode;
    inEndPosition?: boolean;
    mix?: string;
    scrollContent?: (scrollDistance: number) => void;
    scrollStep?: number;
}

export const CarouselNextButton = ({ children, inEndPosition, mix, scrollContent, scrollStep }: Props) => {
    if (typeof scrollContent === 'undefined' || typeof scrollStep === 'undefined') {
        return null;
    }
    if (inEndPosition) {
        return null;
    }

    return (
        <div className={cx('carousel__next-button', mix)} onClick={() => scrollContent(scrollStep)}>
            {children}
        </div>
    );
};
